import { useReduxState } from 'hooks';
import { filterValuesSeparator } from 'shared-helpers/consts';
import {
  HomePageSettingsModulesModuleFooter,
  HomePageSettingsModulesModuleUpdateSettings,
  HomePageSettingsTilesCalendarEvents
} from '.';

import type { ModuleInSettings } from './HomePageSettingsModules';

interface Props {
  module: ModuleInSettings;
  updateModule: (module: ModuleInSettings) => void;
}

const HomePageSettingsModulesModuleCalendarEventsSelected = ({
  module,
  updateModule
}: Props) => {
  const { messages } = useReduxState();

  const url = module.events?.length
    ? `/admin/calendar-events?` +
      `minimal=true` +
      `&view=list` +
      `&page=1` +
      `&sortBy=queryIds` +
      `&limit=${module.events.length}` +
      `&timeFrame=all` +
      `&id=${module.events.join(filterValuesSeparator)}`
    : '';

  return (
    <div>
      <HomePageSettingsTilesCalendarEvents
        includeActions={true}
        module={module}
        updateModule={updateModule}
        url={url}
      />

      <HomePageSettingsModulesModuleFooter
        items={[
          {
            label: messages.commonSelectedCalendarEvents,
            value: module.events?.length || 0
          }
        ]}
      >
        <HomePageSettingsModulesModuleUpdateSettings
          hideLimit={true}
          module={module}
          onUpdate={updateModule}
          productType="calendar-event"
        />
      </HomePageSettingsModulesModuleFooter>
    </div>
  );
};

export default HomePageSettingsModulesModuleCalendarEventsSelected;
